import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/www/wwwroot/fundodo-first/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/fundodo-first/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/fundodo-first/src/components/ui/AppIcon.tsx");
